import React from "react";
import Reveal from "./Reveal";
import { ShieldCheck, Droplets, Wrench } from "lucide-react";

const guarantees = [
  {
    icon: Droplets,
    title: "Prémiová chemie, bez kompromisů",
    body: "Pracujeme výhradně s produkty Koch Chemie (Německo), Gyeon (Korea) a Swiss Wax (Švýcarsko) — světová špička v detailingu. Žádné low-cost alternativy.",
  },
  {
    icon: ShieldCheck,
    title: "Sklokeramika s písemnou zárukou 2 roky",
    body: "U programů Prestige a Supreme dostáváte k aplikaci sklokeramické ochrany Koch písemnou záruku 2 roky. V případě degradace ochrany v záruční době opravíme zdarma.",
  },
  {
    icon: Wrench,
    title: "10+ let zkušeností · špičkové vybavení",
    body: "Detailéři s více než 10 lety praxe. Polishery Flex a Rupes, odsávací systémy, IR lampy a extrakční jednotky — používáme stroje, které na to auto skutečně mají.",
  },
];

export const Guarantee = () => {
  return (
    <section
      id="zaruka"
      data-testid="guarantee-section"
      className="relative py-20 sm:py-24 md:py-36 overflow-hidden"
    >
      <div className="absolute inset-0 -z-10 opacity-[0.06] pointer-events-none">
        <img
          src="https://static.prod-images.emergentagent.com/jobs/d1f5ecef-b7ab-425b-b68e-5aa855d2c4b2/images/1b3985ac53d8f66dfd2a87054f9d58bcb573b0d064b57809db9d5c56d3cab595.png"
          alt=""
          className="w-full h-full object-cover"
          aria-hidden
        />
      </div>

      <div className="max-w-7xl mx-auto px-5 sm:px-6 md:px-10">
        <Reveal className="max-w-3xl">
          <div className="text-[10px] sm:text-[11px] tracking-[0.35em] sm:tracking-[0.4em] uppercase text-[#D4AF37] mb-5 md:mb-6">
            07 — Naše záruky
          </div>
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-white font-light leading-[1.05]">
            Kvalita, která je vidět.
            <br />
            <span className="italic text-gold-gradient">Záruka, která je psaná.</span>
          </h2>
          <p className="mt-5 md:mt-6 text-sm sm:text-base text-zinc-400 font-light max-w-xl leading-relaxed">
            Za každou prací stojí naše jméno. Pracujeme s nejlepší chemií na trhu a dáváme písemné záruky
            tam, kde to má smysl — ne obecná hesla, ale konkrétní závazky.
          </p>
        </Reveal>

        <div className="mt-12 md:mt-16 grid grid-cols-1 md:grid-cols-3 gap-5 sm:gap-6">
          {guarantees.map((g, i) => {
            const Icon = g.icon;
            return (
              <Reveal key={g.title} delay={i * 100} className="gold-border p-7 sm:p-8 md:p-10">
                <div data-testid={`guarantee-item-${i}`}>
                  <Icon className="text-[#D4AF37] mb-5 md:mb-6" size={30} strokeWidth={1} />
                  <h3 className="font-display text-xl sm:text-2xl text-white mb-3">{g.title}</h3>
                  <p className="text-sm text-zinc-400 font-light leading-relaxed">{g.body}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Guarantee;
